import { cx } from "../../utils";

/**
 * Underlined tab strip driven by local state (no routing) — used to split the
 * long app form into sections without losing unsaved values on switch.
 */
const Tabs = ({ tabs, active, onChange, className = "" }) => (
  <div className={cx("flex items-center gap-6 overflow-x-auto border-b border-ink-200", className)}>
    {tabs.map(({ id, label, badge }) => {
      const isActive = id === active;
      return (
        <button
          key={id}
          type="button"
          onClick={() => onChange(id)}
          className={cx(
            "relative inline-flex h-9 shrink-0 items-center gap-1.5 px-1 text-sm font-medium transition-colors",
            isActive ? "text-ink-900" : "text-ink-500 hover:text-ink-800",
          )}
        >
          {label}
          {badge != null && (
            <span
              className={cx(
                "rounded-md px-1.5 text-[11px] font-semibold",
                isActive ? "bg-brand-50 text-brand-700" : "bg-ink-100 text-ink-500",
              )}
            >
              {badge}
            </span>
          )}
          {isActive && (
            <span className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-brand-500" />
          )}
        </button>
      );
    })}
  </div>
);

export default Tabs;
